module.exports = __webpack_public_path__ + "images/500-5e87b8fb44ef632696679a40583de199.svg";